export const  AuthRoutes = {
    login: "/auth/login",
    
  };
    